import React from "react";
import { FC } from "react";
import { Col, Row, Typography } from "antd";
import { IReferralLetter } from "../../../../interfaces/IReferral";
import "../../index.css";
import "./CghsDetailCNM.css";
import dayjs from "dayjs";

type EchsDetailProps = {
  data: IReferralLetter;
  type?: string;
};

const CghsDetailCNM: FC<EchsDetailProps> = ({ data, type }) => {
  const { Text } = Typography;

  const dateFormat = "DD-MM-YYYY ";

  return (
    <div className="cghsDetail-main">
      <Row
        gutter={[16, 16]}
        style={{ width: "100%", margin: "0px" }}
        className="first-row-cghsdetail"
      >
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">BENEFICIARY ID </Text>{" "}
            {data?.beneficiaryId || "-"}
          </div>
        </Col>
        {type === "credit-modal" ? (
          <></>
        ) : (
          <Col span={3}>
            <div
              className="custom-bold-cghs"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Text className="grey-custom-cghs">NAME</Text>{" "}
              {data?.name?.toUpperCase() || "-"}
            </div>
          </Col>
        )}
        {type === "credit-modal" ? (
          <></>
        ) : (
          <Col span={3}>
            <div
              className="custom-bold-cghs"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Text className="grey-custom-cghs">AGE</Text> {data?.age || "-"}
            </div>
          </Col>
        )}
        <Col span={4}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REFFERENCE ID</Text>{" "}
            {data?.refferenceID || "-"}
          </div>
        </Col>
        {type === "credit-modal" ? (
          <Col span={3}>
            <div
              className="custom-bold-cghs"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Text className="grey-custom-cghs">DATE OF ISSUE</Text>{" "}
              {dayjs(data?.dateIssued, "DD-MM-YYYY").format("DD-MMM-YYYY")}
            </div>
          </Col>
        ) : (
          <Col span={3}>
            <div
              className="custom-bold-cghs"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Text className="grey-custom-cghs">DATE OF ISSUE</Text>{" "}
              {data?.dateIssued || "-"}
            </div>
          </Col>
        )}
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">TIME OF ISSUE </Text>{" "}
            {data?.timeIssued || "-"}
          </div>
        </Col>

        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">TOKEN NO</Text>
            {data?.tokenNumber || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REFERRAL BY</Text>{" "}
            {data?.referralBy || "-"}
          </div>
        </Col>
        <Col span={3}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">REMARKS</Text>{" "}
            {data?.remark || "-"}
          </div>
        </Col>

        <Col span={2}>
          <div
            className="custom-bold-cghs"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Text className="grey-custom-cghs">GENDER</Text>{" "}
            {data?.gender?.toUpperCase() || "-"}
          </div>
        </Col>
      </Row>

      {data &&
        data?.referralServicesResponses?.length > 0 &&
        data?.referralServicesResponses?.map((item: any) => (
          <Row
            gutter={[16, 16]}
            style={{ width: "100%", margin: "0px" }}
            className="second-row-cghsdetail"
          >
            <Col span={10}>
              <div
                className="custom-bold-cghs"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Text className="grey-custom-cghs">COMPONENT DETAIL</Text>
                {item?.name || "-"}
              </div>
            </Col>

            <Col span={5}>
              <div
                className="custom-bold-cghs"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Text className="grey-custom-cghs">REFERRAL TYPE</Text>
                {item?.referralType || "-"}
              </div>
            </Col>
            <Col span={5}>
              <div
                className="custom-bold-cghs"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Text className="grey-custom-cghs">VALID UPTO</Text>
                {item?.validUpto
                  ? dayjs(item?.validUpto, "DD-MM-YYYY").format("DD-MMM-YYYY")
                  : "-"}
              </div>
            </Col>
            <Col span={4}>
              <div
                className="custom-bold-cghs"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Text className="grey-custom-cghs">MAX QTY</Text>
                {item?.maxQty || "-"}
              </div>
            </Col>
          </Row>
        ))}
    </div>
  );
};

export default CghsDetailCNM;
